import React from 'react';
import { Modal, Box, Typography } from '@mui/material';
import UserForm from 'components/UserForm/UserForm';

interface EditUserModalProps {
  open: boolean;
  onClose: () => void;
  user: any;
  roleName: string;
  isProfilePage?: boolean
}

const EditUserModal: React.FC<EditUserModalProps> = ({
  open,
  onClose,
  user,
  roleName,
  isProfilePage = false
}) => {
  const handleSuccess = () => {
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        paddingTop: "16px",
        maxHeight: '90vh',
        overflowY: 'auto'
      }}>
        <Typography
          variant="h6"
          noWrap
          component="div"
          fontFamily={'Helvetica Neue LT Std'}
          fontWeight={'300'}
          fontSize={28}
          color={'#1A1A1A'}
          sx={{ mb: 2 }}
        >
          {isProfilePage ? 'My Profile' : `Edit ${roleName}`}
        </Typography>
        <UserForm
          initialData={user}
          roleName={roleName}
          isEditingSelf={isProfilePage}
          buttonText={isProfilePage ? 'Update' : undefined}
          disabledFields={isProfilePage ? ['firm', 'email', 'site_role'] : []}
          onSuccess={handleSuccess}
          onClose={onClose}
        />
      </Box>
    </Modal>
  );
};

export default EditUserModal;